
/**
 * 任务管理日志
 */
import React from 'react'

import {
    message,
    Spin,
    Input,
    DatePicker,
    Select, Button
} from 'antd'

import moment from 'moment';
import 'moment/locale/zh-cn';
import Tools from './tools/Tools'
import WWTable from './components/Table'
import withRouter  from './tools/withRouter'
import DeviceType from './components/DeviceType'
const {RangePicker} = DatePicker;
import InstructHistory from './components/InstructHistory'
import InstructTypeSelect from "./components/InstructTypeSelect";
import SendInstructModal from "./components/SendInstructModal";
class BatchInstructLog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            loading: false,
            pageSize: 10,
            currentPage: 1,
            count: 0,
            record: {},
            windowHeight:window.innerHeight,
            dateFormat:'YYYY-MM-DD HH:mm:ss',
            content: '',
            //todo
            // accountId: localStorage.getItem("currentAccountId") ? localStorage.getItem("currentAccountId") : localStorage.getItem('accountId'),
            accountId:this.props.accountId,
            name:'',
            startTime:'',
            endTime:'',
            routine:'',
        };
        this.getDataList = this.getDataList.bind(this);
        this.searchDataList = this.searchDataList.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.handleDataListChange = this.handleDataListChange.bind(this);
        this.disabledDate = this.disabledDate.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.showDetail = this.showDetail.bind(this);
        this.deletePushDetail = this.deletePushDetail.bind(this);
        this.getParamUrl = this.getParamUrl.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.showHistoryModal = this.showHistoryModal.bind(this);
        this.showSendModal = this.showSendModal.bind(this);
        window.setAccountId = this.setAccountId.bind(this);
    }

    componentDidMount() {
        console.log(this.props)
        if(this.props.location && this.props.location.state){
            const {name} = this.props.location.state;
            name && this.setState({name},()=>{
                this.getDataList();
            })
        } else {
            this.getDataList();
        }
        window.addEventListener('resize', this.onWindowResize)
    }

    componentWillReceiveProps(nextProps) {

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize)
    }
    onWindowResize() {
        this.setState({
            windowHeight: window.innerHeight
        });
    }

    setAccountId(accountId,accountName) {
        this.setState({
            accountId,accountName
        })
    }

    searchDataList() {
        this.setState({
            currentPage: 1,
            loading: true
        }, () => {
            this.getDataList()
        })
    }

    getParamUrl(url) {
        const {imei, routine,accountId,name,startTime,endTime,} = this.state;

        if (!Tools.isNull(routine)) {
            url += '&routine=' + routine;
        }
        if (name) {
            url += '&name=' + name;
        }
        if (imei) {
            url += '&imei=' + imei;
        }
        if (startTime) {
            url += '&startTime=' + moment(startTime).unix();
        }
        if (endTime) {
            url += '&endTime=' + moment(endTime).unix();
        }
        return url
    }

    /*获取设备列表*/
    getDataList() {
        const {currentPage, pageSize,accountId,name,startTime,endTime,} = this.state;
        let url = this.getParamUrl(`${Tools.getApiUrl("taskLogList",this.props.platform)}currentPage=${currentPage}&pageSize=${pageSize}`);
        let urlCount =  this.getParamUrl(Tools.getApiUrl("taskLogCount",this.props.platform));
        let that = this;
        that.setState({
            loading: true,
        });
        Tools.fetch(url,'GET',function (data) {
            that.setState({
                loading: false,
            });
            if(data.code === 0) {
                that.setState({
                    dataList:data.data,
                })
            } else {
                message.error(data.message)
            }
        })
        Tools.fetch(urlCount,'GET',function (data) {
            that.setState({
                loading: false,
            });
            if(data.code === 0) {
                that.setState({
                    count:data.data,
                })
            } else {
                message.error(data.message)
            }
        })
    }

    exportExcel() {
        let url = this.getParamUrl(Tools.getApiUrl("taskLogExport",this.props.platform))
        url += `&zoneId=${Tools.getZoneName()}`;
        window.open(Tools.getNoCacheExportURL(url))
    }

    //切换分页
    handleDataListChange(current, pageSize) {
        this.setState({
            currentPage: current,
            pageSize
        }, () => {
            this.getDataList();
        })

    }


    handleDate(dates, dateStrings) {
        this.setState({
            endTime: dates && dates[1] ,
            startTime: dates && dates[0]
        })
    }

    //结束时间不可选择的时间
    disabledDate(current) {
        const endTime = this.state.endTime;
        const startTime = this.state.startTime;

        if (!endTime || !startTime) {
            return false;
        }
        const tooGreater = startTime.valueOf() > endTime.valueOf();
        const outOfFreeRange = endTime.valueOf() <= startTime.valueOf();
        return tooGreater || outOfFreeRange;
    }

    showDetail(record) {
        this.refs.add.showModal(record.id)
    }

    deletePushDetail(id) {
        let url = `${Tools.getApiUrl("delTaskPush",this.props.platform)}${id}`
        let that = this;
        Tools.fetch(url,'DELETE',function (data) {
            if(data.code === 0) {
                message.success(Strings.rs10659)
                that.searchDataList();
            } else {
                message.error(data.message)
            }
        })
    }

    showHistoryModal(record,status) {
        if(Tools.isMonitor()) {
            return
        }
        this.refs.history.showModal(record,status)
    }

    showSendModal(record) {
        this.refs.send.showModal(record)
    }

    render() {
        let that = this;
        const {windowHeight, accountId, dateFormat, pageSize, count, currentPage,startTime,endTime,routine} = this.state;
        let columns = [
            {
                title: Strings.rs14375 || Strings.taskname,
                width: "10%",
                dataIndex: 'taskName',
            }, {
                title: Strings.rs14394 || Strings.directivename,//指令名称
                dataIndex: 'instructionName',
                width: "10%",
            }, {
                title: Strings.rs10065 || Strings.devicecount,
                dataIndex: 'deviceNum',
                width: "8%",
                render:(text, record, index) =>{
                    return <a onClick={()=>that.showHistoryModal(record)}>{text}</a>
                }
            }, {
                title: Strings.rs14383,
                dataIndex: 'repliedNum',
                width: "8%",
                render:(text, record, index) =>{
                    return <a onClick={()=>that.showHistoryModal(record,'1')}>{text}</a>
                }
            }, {
                title: Strings.rs14384,
                dataIndex: 'noResponseNum',
                width: "10%",
                render:(text, record, index) =>{
                    return <a onClick={()=>that.showHistoryModal(record,'0')}>{text}</a>
                }
            }, {
                title: Strings.rs14385,
                dataIndex: 'noSupportNum',
                width: "10%",
                render:(text, record, index) =>{
                    return <a onClick={()=>that.showHistoryModal(record,'3')}>{text}</a>
                }
            }, {
                title: Strings.rs14386,
                dataIndex: 'operator',
                width: "10%",
            }, {
                title: Strings.rs14379 || Strings.lastexetime,
                dataIndex: 'lastExecTimeDesc',
                width: "10%",
            }, {
                title: Strings.rs10091 || Strings.opts,
                dataIndex: '',
                width: "10%",
                render: function (text, record) {
                    return  <div className="more-operation inline-flex">
                        <a onClick={()=>that.showSendModal(record)}>{Strings.rs10357 || Strings.send}</a>
                    </div>
                },
            }];
        if(Tools.isMonitor()) {
            columns.splice(8,1)
        }
        let header =
            <div className="search_content">
                <div className="search_row mg_bottom16">
                    <div className="row_item">
                        <span className="label">{Strings.rs14375 || Strings.taskname}</span>
                        <Input
                            onChange={(e) => {
                                this.setState({
                                    name: Tools.removeSpace(e.target.value),
                                })
                            }}
                            value={this.state.name} placeholder={Strings.rs14325}/>
                    </div>
                    <div className="row_item">
                        <span className="label">{Strings.rs14394 || Strings.directivename}</span>
                        <InstructTypeSelect value={routine} width={230}
                                            showAll={true}
                                            onChange={(value)=>this.setState({routine:value})}/>
                    </div>
                    <div className="row_item"  id="instruct_log_picker">
                        <span className="label">{Strings.rs14379 || Strings.lastexetime}</span>
                        <RangePicker
                            size={"middle"}
                            showTime={true}
                            picker="date"
                            allowClear={true}
                            value={[startTime ? moment(startTime, dateFormat) : '', endTime ? moment(endTime, dateFormat) : '']}
                            format={dateFormat}
                            onChange={this.handleDate}
                            // disabledDate={this.disabledDate}
                            getPopupContainer={() => document.getElementById("instruct_log_picker")}/>
                    </div>
                </div>
                <div className="search_row">
                    <div className="row_item">
                        <span className="label">{Strings.rs10026 || Strings.deviceName}</span>
                        <DeviceType ref="deviceaName" type={(imei)=>this.setState({imei})} imei={this.state.imei} accountId={accountId}/>
                    </div>
                    <div className="row_item flex_end">
                        <Button className={"mgl15"} type={"primary"} title={Strings.rs10025} onClick={this.searchDataList}>
                            <i className={"iconfont icon-sousuo"}></i>
                        </Button>
                    </div>
                </div>
            </div>

        return (
            <Spin delay={2000} spinning={this.state.loading}>
                <div className="component_header">{Strings.rs14373}</div>
                {header}
                <div className="component_table_content new_app_table_content"
                     style={{height: windowHeight - 168, position: 'relative'}}>
                    <WWTable className="new_app_table"
                             dataSource={this.state.dataList}
                             columns={columns}
                             pageSize={pageSize}
                             count={count}
                             currentPage={currentPage}
                             innerHeight={windowHeight - 238}
                             exportExcel={this.exportExcel}
                             onShowSizeChange={this.handleDataListChange}/>
                </div>
                <InstructHistory ref={'history'} refresh={this.searchDataList}/>
                <SendInstructModal ref={'send'} refresh={this.searchDataList}/>
            </Spin>
        )
    }
}

export default withRouter(BatchInstructLog)
